
import { RevLink } from '@ds/components/Link'
import { RevToast } from '@ds/components/Toast'
import isEmpty from 'lodash/isEmpty'

import { TOAST_DASHBOARD_MY_FAVORITES_TOGGLE } from '@config/constants/toasts'
import logger from '@logger'
import { ROUTES } from '@router'
import { PAGE_TYPE_BY_ROUTE_NAME } from '@tracking/constants'
import { trackClick, trackToastView } from '@tracking/events'

import { LOG_ERROR_MESSAGE } from '../../MyFavorites.constants'

import { TOAST_TYPE, TRACKING } from './Notification.constants'
import translations from './Notification.translations'

export default {
  components: {
    RevLink,
    RevToast,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },

    type: {
      type: String,
      default: '',
    },
  },

  data() {
    return { routeName: this.$route.name }
  },

  computed: {
    translations: () => translations,
    ROUTES: () => ROUTES,
    toastName: () => TOAST_DASHBOARD_MY_FAVORITES_TOGGLE,

    isUndoToast() {
      return this.type === TOAST_TYPE.UNDO
    },

    isLinkVisible() {
      return !this.isUndoToast && !isEmpty(this.toast.to)
    },

    toast() {
      switch (this.type) {
        case TOAST_TYPE.SAVED:
          return {
            title: this.$t(translations.toastSaveTitle),
            message: this.$t(translations.toastSaveDescription),
            variant: 'success',
            iconSrc: this.$static('/img/toast/rabbit.svg'),
            actionText: this.$t(translations.toastSaveActionText),
            to: { name: ROUTES.DASHBOARD.FAVORITES },
          }

        case TOAST_TYPE.ALREADY_SAVED:
          return {
            title: this.$t(translations.toastAlreadySavedTitle),
            message: this.$t(translations.toastAlreadySavedDescription),
            variant: 'success',
            iconSrc: this.$static('/img/toast/rabbit.svg'),
            actionText: this.$t(translations.toastAlreadySaveActionText),
            to: { name: ROUTES.DASHBOARD.FAVORITES },
          }

        case TOAST_TYPE.UNDO:
          return {
            title: this.$t(translations.toastUndoTitle),
            message: this.$t(translations.toastUndoDescription),
            variant: 'error',
            iconSrc: this.$static('/img/toast/storm.svg'),
            actionText: this.$t(translations.toastUndoActionText),
          }

        case TOAST_TYPE.ADDED_TO_CART:
          return {
            title: this.$t(translations.toastAddToCartTitle),
            message: this.$t(translations.toastAddToCartDescription),
            variant: 'success',
            iconSrc: this.$static('/img/toast/rabbit.svg'),
          }

        default:
          logger.error(LOG_ERROR_MESSAGE.NOTIFICATION)

          return {
            title: '',
            variant: '',
            iconSrc: '',
          }
      }
    },
  },

  watch: {
    open: {
      handler() {
        if (!this.isUndoToast && this.open) {
          this.trackImpression()
        }
      },

      immediate: true,
    },
  },

  methods: {
    trackImpression() {
      const name = TRACKING.IMPRESSION[this.type]
      const pageType = PAGE_TYPE_BY_ROUTE_NAME[this.routeName]

      trackToastView({ name, pageType })
    },

    trackLinkClick() {
      const name = TRACKING.CLICK
      const pageType = PAGE_TYPE_BY_ROUTE_NAME[this.routeName]
      const zone = TRACKING.ZONE

      trackClick({ name, pageType, zone })
    },

    undo() {
      this.$emit('undo')
    },

    close() {
      const eventName =
        this.type === TOAST_TYPE.UNDO ? 'close-undo-toast' : 'close'

      this.$emit(eventName)
    },
  },
}
